import Http from '../../../helpers/Http'
import { toast } from 'react-toastify'
import axios from 'axios'
import { BASE_URL } from '../../../constant'
import { printApiError } from '../../../helpers/Util'

export const fetchSharedCollection = async (params, requetBody) => {
    try {
        const { data } = await Http.POST(
            'searchCollectionByUser',
            requetBody,
            params
        )
        return data
    } catch (error) {
        printApiError(error)
    }
}

export const fetchCollectionStyeWise = async (params, requetBody) => {
    try {
        const { data } = await Http.POST(
            'fetchCollectionStyleWise',
            requetBody,
            params
        )
        return data
    } catch (error) {
        if (error?.response?.data?.message) {
            toast.error(error.response.data.message)
        } else {
            toast.error('Something went wrong! Please try again.')
        }
        throw error
    }
}

export const likeSharedCollection = async (collectionId, folderId) => {
    try {
        const { data } = await axios.post(
            `${BASE_URL}/collection/${collectionId}/like?folderId=${folderId}`
        )
        return data
    } catch (error) {
        if (error?.response?.data?.message) {
            toast.error(error.response.data.message)
        } else {
            toast.error('Something went wrong! Please try again.')
        }
        throw error
    }
}

export const fetchCollectionInfo = async (collectionId) => {
    try {
        const { data } = await axios.get(
            `${BASE_URL}/collection/${collectionId}/with-moodboard-details`
        )
        return data
    } catch (error) {
        if (error?.response?.data?.message) {
            toast.error(error.response.data.message)
        } else {
            toast.error('Something went wrong! Please try again.')
        }
        throw error
    }
}
